'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:loginCtrl
 * @description
 * # loginCtrl
 * Controller of the myConsultApp
 */
angular.module('myConsultApp').controller('logoutCtrl', function ($rootScope) {
  $rootScope.logout();
});
